import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', this.addAnother.bind(this));
  }

  addAnother(e) {
    e.preventDefault();
    const elementToClone = this.element.previousElementSibling;
    const clone = elementToClone.cloneNode(true);
    elementToClone.after(clone);
    clone.classList.remove('hidden');

    // Clear out any values in the clone
    clone.querySelectorAll('input,select,textarea').forEach((input) => {
      input.value = '';
    });

    this.dispatch('added', { detail: { clone: clone } })
  }
}